import React, {useEffect, useState} from 'react'
import {useTranslation} from "react-i18next";
import Input from "../../../../common/src/components/widget/Input";
import PhoneNumber from "../../../../common/src/components/widget/PhoneNumber";
import DateTimePicker
  from "../../../../common/src/components/widget/DateTimePicker";
import Checkbox from "../../../../common/src/components/widget/Checkbox";
import CheckboxGroup from "common/src/components/widget/CheckboxGroup";
import {getValue} from "common/src/components/widget/Component";

function ClientCard(props) {
  const {t} = useTranslation();
  const [isMainGuest, setIsMainGuest] = useState(true);
  useEffect(() => {
    let main = getValue(props.mainGuest);
    if(typeof main === 'boolean') {
      setIsMainGuest(main);
    }

  }, [getValue(props.mainGuest)])

  const handleChangedIsMainGuest = () => {
    props.mainGuest.setValue(!isMainGuest, undefined, getValue(props.mainGuest) !== "");
    setIsMainGuest(!isMainGuest);
  };

  return (
    <div className="card">
      <header className="card-header">
        <p className="card-header-title">
          <span className="icon fz fz-user medium mr-1"/>
          <span>{t("client")}</span>
        </p>
      </header>
      <div className="card-content">
        <div className="columns">
          <div className="column">
            <Input label={t('first_name')} formField={props.name}
                   disabled={!props.isEditable}/>
          </div>
          <div className="column">
            <Input label={t('last_name')} formField={props.surname}
                   disabled={!props.isEditable}/>
          </div>
          <div className="column">
            <PhoneNumber label={t('mobile_number')}
                         formField={props.mobileNumber}
                         disabled={!props.isEditable}/>
          </div>
          <div className="column">
            <Input label={t('email')} formField={props.email}
                   disabled={!props.isEditable}/>
          </div>
          <div className="column">
            <DateTimePicker label={t('date_of_birth')}
                            formField={props.dateOfBirth}
                            disabled={!props.isEditable}/>
          </div>
        </div>
        <CheckboxGroup formField={props.mainGuest}>
          <div className="columns">
            <div className="column">
              <Checkbox
                label={t('main_guest')}
                type="form"
                color="auto"
                onChange={handleChangedIsMainGuest}
                checked={isMainGuest}
                disabled={!props.isEditable}
              />
            </div>
            <div className="column">
              <Checkbox
                label={t('not_main_guest')}
                type="form"
                color="auto"
                onChange={handleChangedIsMainGuest}
                checked={!isMainGuest}
                disabled={!props.isEditable}
              />
            </div>
          </div>
        </CheckboxGroup>
      </div>
    </div>
  );
}

export default ClientCard;
